import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_5ef9b9a2 from 'nuxt_plugin_plugin_5ef9b9a2' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_a4625b26 from 'nuxt_plugin_cookieuniversalnuxt_a4625b26' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_64555cc5 from 'nuxt_plugin_axios_64555cc5' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_mixins_3b2fbd9e from 'nuxt_plugin_mixins_3b2fbd9e' // Source: ../plugins/mixins.js (mode: 'all')
import nuxt_plugin_request_735f5dfc from 'nuxt_plugin_request_735f5dfc' // Source: ../plugins/request.js (mode: 'all')
import nuxt_plugin_pointsCache_01902c2c from 'nuxt_plugin_pointsCache_01902c2c' // Source: ../plugins/pointsCache.js (mode: 'all')
import nuxt_plugin_route_58147902 from 'nuxt_plugin_route_58147902' // Source: ../plugins/route.js (mode: 'all')
import nuxt_plugin_vuelazyload_d7e169bc from 'nuxt_plugin_vuelazyload_d7e169bc' // Source: ../plugins/vue-lazyload.js (mode: 'client')
import nuxt_plugin_i18n_66ff12a5 from 'nuxt_plugin_i18n_66ff12a5' // Source: ../plugins/i18n.js (mode: 'all')
import nuxt_plugin_vuequilleditor_59693810 from 'nuxt_plugin_vuequilleditor_59693810' // Source: ../plugins/vue-quill-editor (mode: 'client')
import nuxt_plugin_clipboard_08485495 from 'nuxt_plugin_clipboard_08485495' // Source: ../plugins/clipboard.js (mode: 'client')
import nuxt_plugin_video_c73adce0 from 'nuxt_plugin_video_c73adce0' // Source: ../plugins/video.js (mode: 'client')
import nuxt_plugin_elementui_2bfe913c from 'nuxt_plugin_elementui_2bfe913c' // Source: ../plugins/element-ui/element-ui.js (mode: 'all')
import nuxt_plugin_xcoinsConfirm_5c260f55 from 'nuxt_plugin_xcoinsConfirm_5c260f55' // Source: ../plugins/xcoinsConfirm.js (mode: 'client')
import nuxt_plugin_storage_bc9a12e0 from 'nuxt_plugin_storage_bc9a12e0' // Source: ../plugins/storage.js (mode: 'client')
import nuxt_plugin_emoji_c5dee436 from 'nuxt_plugin_emoji_c5dee436' // Source: ../plugins/emoji.js (mode: 'client')
import nuxt_plugin_ga_22722969 from 'nuxt_plugin_ga_22722969' // Source: ../plugins/ga.js (mode: 'client')
import nuxt_plugin_gtm_2cfa83cb from 'nuxt_plugin_gtm_2cfa83cb' // Source: ../plugins/gtm.js (mode: 'client')
import nuxt_plugin_hwtag_248a3840 from 'nuxt_plugin_hwtag_248a3840' // Source: ../plugins/hwtag.js (mode: 'client')
import nuxt_plugin_googlesignin_0f206a75 from 'nuxt_plugin_googlesignin_0f206a75' // Source: ../plugins/google-signin.js (mode: 'client')
import nuxt_plugin_applesignin_ad91a024 from 'nuxt_plugin_applesignin_ad91a024' // Source: ../plugins/apple-signin.js (mode: 'client')
import nuxt_plugin_sentry_82ffc378 from 'nuxt_plugin_sentry_82ffc378' // Source: ../plugins/sentry.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"XPPen Community","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"keywords","content":"xppen-xfans-community"},{"name":"description","content":"XPPen Community is a platform focused on communication, creation, and sharing among XPPen fans. It includes sections such as courses, leaderboards, posts, activities, and other interesting content."},{"name":"google-site-verification","content":"GFlkHQkSlf9w5IK0BwjnolEJeU7xc8rkA7XRe7MzJ-A"},{"name":"baidu-site-verification","content":"codeva-Li9Ct1hiqw"}],"script":[{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-HKXF28E9VM","async":true},{"src":"https:\u002F\u002Fcommunity.xp-pen.com\u002Fpixel.js","async":true}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_5ef9b9a2 === 'function') {
    await nuxt_plugin_plugin_5ef9b9a2(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_a4625b26 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_a4625b26(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_64555cc5 === 'function') {
    await nuxt_plugin_axios_64555cc5(app.context, inject)
  }

  if (typeof nuxt_plugin_mixins_3b2fbd9e === 'function') {
    await nuxt_plugin_mixins_3b2fbd9e(app.context, inject)
  }

  if (typeof nuxt_plugin_request_735f5dfc === 'function') {
    await nuxt_plugin_request_735f5dfc(app.context, inject)
  }

  if (typeof nuxt_plugin_pointsCache_01902c2c === 'function') {
    await nuxt_plugin_pointsCache_01902c2c(app.context, inject)
  }

  if (typeof nuxt_plugin_route_58147902 === 'function') {
    await nuxt_plugin_route_58147902(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazyload_d7e169bc === 'function') {
    await nuxt_plugin_vuelazyload_d7e169bc(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_66ff12a5 === 'function') {
    await nuxt_plugin_i18n_66ff12a5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuequilleditor_59693810 === 'function') {
    await nuxt_plugin_vuequilleditor_59693810(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clipboard_08485495 === 'function') {
    await nuxt_plugin_clipboard_08485495(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_video_c73adce0 === 'function') {
    await nuxt_plugin_video_c73adce0(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_2bfe913c === 'function') {
    await nuxt_plugin_elementui_2bfe913c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_xcoinsConfirm_5c260f55 === 'function') {
    await nuxt_plugin_xcoinsConfirm_5c260f55(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_storage_bc9a12e0 === 'function') {
    await nuxt_plugin_storage_bc9a12e0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_emoji_c5dee436 === 'function') {
    await nuxt_plugin_emoji_c5dee436(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ga_22722969 === 'function') {
    await nuxt_plugin_ga_22722969(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_2cfa83cb === 'function') {
    await nuxt_plugin_gtm_2cfa83cb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hwtag_248a3840 === 'function') {
    await nuxt_plugin_hwtag_248a3840(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlesignin_0f206a75 === 'function') {
    await nuxt_plugin_googlesignin_0f206a75(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_applesignin_ad91a024 === 'function') {
    await nuxt_plugin_applesignin_ad91a024(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentry_82ffc378 === 'function') {
    await nuxt_plugin_sentry_82ffc378(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
